import Container from '@/components/shared/Container'
import { useEffect, useState } from 'react'
import classNames from '@/utils/classNames'
import Avatar from '@/components/ui/Avatar'
// import { APP_NAME } from '@/constants/app.constant'
import { PAGE_CONTAINER_GUTTER_X } from '@/constants/theme.constant'
import { fetchAppVersionService } from '@/services/appVersion/appVersionService'
import { useAppVersion } from '@/context/AppVersionContext'

export type FooterPageContainerType = 'gutterless' | 'contained'

type FooterProps = {
    pageContainerType: FooterPageContainerType
    className?: string
}

const FooterContent = ({  appVersion }: {  appVersion: string }) => {





    // useEffect(() => {
    //     fetchVersion()
    // }, [])



    return (
        <div className="flex items-center justify-between md:flex-row flex-col flex-auto w-full">
            <span className='text-center md:text-left'>
                Copyright &copy; {`${new Date().getFullYear()}`}{' '} | OASYS Cybernetics Pvt Ltd. All
                rights reserved.
                {/* <span className="font-semibold">{`${APP_NAME}`}</span>  */}
                {appVersion && (
                    <span className="ml-1 text-xs text-muted">
                        v{appVersion}
                    </span>
                )}
            </span>
            <div className="flex items-center">
                {/* <a
                    className="text-gray"
                    href="/#"
                    onClick={(e) => e.preventDefault()}
                >
                    Term & Conditions
                </a>
                <span className="mx-2 text-muted"> | </span>
                <a
                    className="text-gray"
                    href="/#"
                    onClick={(e) => e.preventDefault()}
                >
                    Privacy & Policy
                </a> */}

                {/* ✅ Dynamic App Version */}

                Powered By <img className="ml-3" src="/portal/img/logo/poweredby-icon.png" />
            </div>
        </div>
    )
}

export default function Footer({
    pageContainerType = 'contained',
    className,
}: FooterProps) {
     const { appVersion } = useAppVersion()
    // const [appVersion, setAppVersion] = useState<string>('')
    // const fetchVersion = async () => {
    //     try {
    //         const result = await fetchAppVersionService()
    //         const version =
    //             result?.responseContent?.[0]?.app_version
    //         setAppVersion(version)
    //     } catch (error) {
    //         console.error('Failed to fetch app version', error)
    //     }
    // }

    return (
        <footer
            className={classNames(
                `footer flex flex-auto items-center h-16 border-t ${PAGE_CONTAINER_GUTTER_X}`,
                className,
            )}
        >
            {pageContainerType === 'contained' ? (
                <Container>
                    <FooterContent appVersion={appVersion} />
                </Container>
            ) : (
                <FooterContent appVersion={appVersion} />
            )}
        </footer>
    )
}
